module.exports = __webpack_public_path__ + "static/media/list-view-active.9268a4b1.svg";